import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./locales/en.json";
import es from "./locales/es.json";
import fr from "./locales/fr.json";
import ht from "./locales/ht.json";

export const SUPPORTED_LANGS = [
  { code: "en", label: "English", native: "English", flag: "🇺🇸" },
  { code: "es", label: "Spanish", native: "Español", flag: "🇪🇸" },
  { code: "fr", label: "French", native: "Français", flag: "🇫🇷" },
  { code: "ht", label: "Haitian Creole", native: "Kreyòl Ayisyen", flag: "🇭🇹" },
];

export const LANG_CODES = SUPPORTED_LANGS.map((l) => l.code);

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      es: { translation: es },
      fr: { translation: fr },
      ht: { translation: ht },
    },
    fallbackLng: "en",
    supportedLngs: LANG_CODES,
    load: "languageOnly",
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "hb_lang",
      caches: ["localStorage"],
    },
    react: { useSuspense: false },
  });

export default i18n;

export function setLanguage(code) {
  if (!LANG_CODES.includes(code)) code = "en";
  i18n.changeLanguage(code);
  localStorage.setItem("hb_lang", code);
  document.documentElement.lang = code;
}
